import { Button } from 'antd';
import Link from 'next/link';
import styled from 'styled-components';

type Props = {
    category: Pick<ContestCategory, 'contest' | 'name' | 'id'>;
    article: Pick<Article, 'seoSlug'>;
};

const Container = styled.div`
    font-size: 18px;
    text-align: center;
    padding-bottom: 35px;
`;

const Paragraph = styled.p`
    margin-bottom: 5px;
`;

const A = styled(Link)`
    font-weight: bold;
`;

const ContestSection = ({ category, article }: Props) => (
    <Container>
        <Paragraph>
            Zagłosuj na ten produkt w konkursie{' '}
            <A href={`/konkursy/${category.contest.seoSlug}`} passHref>
                {category.contest.name}
            </A>{' '}
            w kategorii{' '}
            <A href={`/konkursy/${category.contest.seoSlug}#category__${category.id}`} passHref>
                {category.name}
            </A>
        </Paragraph>
        <Link
            href={`/konkursy/${category.contest.seoSlug}?vote=true&voteCategory=${category.id}&voteArticle=${article.seoSlug}#category__${category.id}__${article.seoSlug}`}
        >
            <Button type="primary">zagłosuj</Button>
        </Link>
    </Container>
);

export default ContestSection;
